module.exports = __webpack_public_path__ + "12786efedbfe8904483f40028f4e9486.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/components/CloudGradientSection/images/img_mission_cloud01.svg
// module id = 1266
// module chunks = 7